import _asyncToGenerator from "F:/vue2.0+ vant/2024\u5E74\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u5B98\u7F51\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u82F1\u6587\u7248\u672C/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { enGetDiseaseFieldList_url, enGetHomePipelineInnovationList_url } from '@/api'; //引入发送请求获取数据的方法

export default {
  components: {},
  name: 'Domain',
  setup: function setup() {
    // require('@/pages/index/images/banner1.png')
    var domainList = [// {
      //   id: 1,
      //   text: 'CDKL5 缺乏症（CDD）',
      //   iconImg: require('../images/pipeline_top_01.png'),
      // },
      // {
      //   id: 2,
      //   text: '难治性癫痫状态 (RSE)  ',
      //   iconImg: require('../images/pipeline_top_02.png'),
      // },
      // {
      //   id: 3,
      //   text: '特发性震颤',
      //   iconImg: require('../images/pipeline_top_03.png'),
      // },
    ];
    var domainIndex = ref(-1); // const displayedItems = ref(items.slice(0, 2))

    var showMore = ref(false);
    var activeNames = ref(-1);
    var articleList = ref([]);
    var hiddenIndex = ref(-1); // onMounted(() => {
    // })

    var handleSticky = null;
    var handleResize = null;
    onMounted(function () {
      getDiseaseFieldList();
      getHomePipelineInnovationList();
      var lineTitleBoxFexd = document.querySelector('.line_title_box_fexd');
      var lineTitleBox = document.querySelector('.line_title_box');
      var headerBox = document.querySelector('.outer-container-header .long-container');
      lineTitleBoxFexd.style.display = 'none';

      var updateStickyTopAndStatus = function updateStickyTopAndStatus() {
        if (!lineTitleBoxFexd || !lineTitleBox) return;
        var headerHeight = headerBox ? headerBox.getBoundingClientRect().height : 0;
        lineTitleBoxFexd.style.top = "".concat(headerHeight, "px");
        var lineTitleBoxRect = lineTitleBox.getBoundingClientRect(); // 当原始标题触碰到导航底部时开启吸顶

        if (lineTitleBoxRect.top <= headerHeight) {
          lineTitleBoxFexd.style.display = 'block';
          lineTitleBoxFexd.style.opacity = '1';
        } else {
          lineTitleBoxFexd.style.display = 'none';
        }
      };

      handleSticky = function handleSticky() {
        updateStickyTopAndStatus();
      };

      handleResize = function handleResize() {
        updateStickyTopAndStatus();
      };

      updateStickyTopAndStatus();
      window.addEventListener('scroll', handleSticky, {
        passive: true
      });
      window.addEventListener('resize', handleResize);
    });
    onBeforeUnmount(function () {
      if (handleSticky) {
        window.removeEventListener('scroll', handleSticky);
      }

      if (handleResize) {
        window.removeEventListener('resize', handleResize);
      }
    });

    var getHomePipelineInnovationList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return enGetHomePipelineInnovationList_url();

              case 2:
                res = _context.sent;
                // console.log(res, '这是获取到的数据')
                articleList.value = res.data;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getHomePipelineInnovationList() {
        return _ref.apply(this, arguments);
      };
    }();

    var fieldList = ref([]);

    var getDiseaseFieldList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return enGetDiseaseFieldList_url();

              case 2:
                res = _context2.sent;
                fieldList.value = res.data; // console.log(res, '疾病领域列表')

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getDiseaseFieldList() {
        return _ref2.apply(this, arguments);
      };
    }();

    var toggleMore = function toggleMore(index) {
      if (index == activeNames.value) {
        activeNames.value = -1;
      } else {
        activeNames.value = index;
        hiddenIndex.value = -1; // console.log(activeNames.value, '看看是啥')
      }
    };

    var toggleMoreTrue = function toggleMoreTrue(index) {
      //点击头部ICON切换
      showMore.value = true;
      domainIndex.value = index;
    };

    var retract = function retract(name) {
      activeNames.value = -1;
    };

    var showPop = function showPop(val) {
      hiddenIndex.value = val;
      activeNames.value = -1;
    };

    var closePop = function closePop() {
      hiddenIndex.value = -1; // console.log('关闭方法执行了', hiddenIndex.value)
    };

    return {
      fieldList: fieldList,
      domainList: domainList,
      domainIndex: domainIndex,
      showMore: showMore,
      activeNames: activeNames,
      articleList: articleList,
      closePop: closePop,
      toggleMoreTrue: toggleMoreTrue,
      toggleMore: toggleMore,
      retract: retract,
      showPop: showPop,
      hiddenIndex: hiddenIndex
    };
  }
};